import { registerBidder } from '../src/adapters/bidderFactory.js';
import { BANNER, NATIVE, VIDEO } from '../src/mediaTypes.js';
import { isBidRequestValid, buildRequests, interpretResponse, getUserSyncs } from '../libraries/teqblazeUtils/bidderUtils.js';

const BIDDER_CODE = 'ads_interactive';
const AD_URL = 'https://bntb.adsinteractive.com/pbjs';
const SYNC_URL = 'https://cstb.adsinteractive.com';
const GVLID = 1212;

export const spec = {
  code: BIDDER_CODE,
  gvlid: GVLID,
  aliases: [
    'adsinteractive'
  ],
  supportedMediaTypes: [BANNER, VIDEO, NATIVE],

  isBidRequestValid: isBidRequestValid(),
  buildRequests: buildRequests(AD_URL),
  interpretResponse,
  getUserSyncs: getUserSyncs(SYNC_URL)
};

registerBidder(spec);
